export function s3ToFileName(s3_key) {
    let spitedS3 = s3_key?.split('/')
    if (spitedS3?.length > 0) {
        return spitedS3[spitedS3?.length - 1]
    }
    return ""
}